import React, {useState} from 'react';
import "./meetingSummary.scss";
import PropTypes from 'prop-types';
import {CALL_SUMMARY_FORMAT, CALL_SUMMARY_LENGTH, ERROR_DATA_NOT_FOUND, USER_EVENTS} from "../constants";
import Metrics from '../services/Metrics';

const Options = ({summaryOptions, activeTabKey, clickHandler}) => {
    return <div>
        <p className={"option-sub-title"}>{summaryOptions.name}</p>
        <div className={"options"}>
            {
                summaryOptions.options.map(({name, key}) => <button
                    key={key}
                    className={`option-tab ${activeTabKey === key ? "activeTab" : ""}`}
                    onClick={() => {clickHandler(key)}}>
                    <p>{name}</p>
                </button>)
            }
        </div>
    </div>;
}

const MeetingSummary = (callSummary) => {
    const [activeFormat, setActiveFormat] = useState(CALL_SUMMARY_FORMAT.BULLET_LIST.key);
    const [activeLength, setActiveLength] = useState(CALL_SUMMARY_LENGTH.SHORT.key);

    const summaryOptions = {
        Format: {
            name: 'Format',
            options: [CALL_SUMMARY_FORMAT.BULLET_LIST, CALL_SUMMARY_FORMAT.PARAGRAPH]
        },
        Length: {
            name: "Length",
            options: [CALL_SUMMARY_LENGTH.SHORT, CALL_SUMMARY_LENGTH.MEDIUM, CALL_SUMMARY_LENGTH.LONG]
        }
    }
    const handleFormatChange = (key) => {
        setActiveFormat(key)

        Metrics.track(`${USER_EVENTS.CLICKED_SUMMARY_FORMAT} - ${key}`, { format: key });
    }
    const handleLengthChange = (key) => {
        setActiveLength(key)

        Metrics.track(`${USER_EVENTS.CLICKED_SUMMARY_LENGTH} - ${activeLength}`, { length: activeLength });
    }

    return <>
        <p className={"section-title"}>Summary</p>
        {
            callSummary.hasError ? <p>{ERROR_DATA_NOT_FOUND.SUMMARY}</p>
                : <>
                    <div className={"options-tab"}>
                        <Options summaryOptions={summaryOptions.Format} activeTabKey={activeFormat} clickHandler={handleFormatChange} />
                        <Options summaryOptions={summaryOptions.Length} activeTabKey={activeLength} clickHandler={handleLengthChange} />
                    </div>
                    {
                        activeFormat === CALL_SUMMARY_FORMAT.BULLET_LIST.key ? <ul className={"summary-in-bullets"}>
                            {
                                callSummary[activeLength][activeFormat].map((summaryPoint, index) => <li key={index}>{summaryPoint}</li>)
                            }
                        </ul> : <p className={"paragraph-summary"}>{callSummary[activeLength][activeFormat]}</p>
                    }
                </>
        }

    </>
}

MeetingSummary.prototype = {
    smallSummary: PropTypes.shape({
        bulletPoint: PropTypes.arrayOf(PropTypes.string),
        paragraph: PropTypes.string
    }),
    mediumSummary: PropTypes.shape({
        bulletPoint: PropTypes.arrayOf(PropTypes.string),
        paragraph: PropTypes.string
    }),
    longSummary: PropTypes.shape({
        bulletPoint: PropTypes.arrayOf(PropTypes.string),
        paragraph: PropTypes.string
    }),
    hasError: PropTypes.bool
}
export default MeetingSummary;